import { useEligibleOptions } from "./selectOptionsField/SelectOptionsDialog";
import { DialogContent, DialogTitle, IconButton, Stack, Typography } from "@mui/material";
import { T } from "components/util/t";
import { ChevronRight, Close } from "@mui/icons-material";
import { PriceDescriptions } from "./selectOptionsField/PriceDescriptions";
import { SearchForm } from "components/search/search";
import { useSimpleListFilter } from "hooks/useListFilter";
import { useTakeoverDialogStyles } from "../forms/SearchTakeoverDialog";
import { SimpleList } from "../lists/SimpleList";
import { OptionLabel } from "./selectOptionsField/OptionLabel";
import { OptionPrice } from "./selectOptionsField/OptionPrice";
import { useWatch } from "react-hook-form";

const getOptionLabel = option => option.name;

export const getRegisteredEntriesByDivision = (entries, divisionId) => entries.filter(entry => entry.registrations_attributes.some(registration => registration.option_id === divisionId));
export const getRegisteringEntriesByDivision = (entries, divisionId) => entries.filter(entry => entry.team_members && entry.registrations_attributes[0].option_id === divisionId);

export const createTeamEntry = (eventTeam, registered, registering, option) => ({
    name : [eventTeam, `Team ${String.fromCharCode(65 + (eventTeam ? registered.filter(entry => entry.registrations_attributes[0].team_name === eventTeam) : registered).length + registering.length)}`, "-", option.name].filter(v => v).join(" "),
    team_members: [],
    registrations_attributes: [{ option_id: option.optionId, name: option.name }]
});

export const SelectDivisionDialog = ({ athletes, closeDialog, teamDivisions, appendAthlete, formAthletes, registrationOptions, paymentOptions, control, dialogId }) => {
    const [eligible, ineligible] = useEligibleOptions({ options: teamDivisions, athlete: formAthletes[0], athletes: formAthletes, index: 0, registrationOptions, paymentOptions });
    const eventTeam = useWatch({ name: "team.name", control });

    const {
        inputRef,
        searchString,
        onSearch,
        filteredList
    } = useSimpleListFilter(eligible.concat(ineligible), getOptionLabel);
    const showSubtext = registrationOptions?.divisionLimit || paymentOptions;
    const dialogStyles = useTakeoverDialogStyles();

    const selectDivision = option => () => {
        const registered = getRegisteredEntriesByDivision(athletes, option.optionId);
        const registering = getRegisteringEntriesByDivision(formAthletes, option.optionId);
        const index = registering[0] && formAthletes.findIndex(entry => entry.name === registering[0]?.name);
        appendAthlete(createTeamEntry(eventTeam, registered, registering, option), index);
        closeDialog();
    };

    return (
        <>
            <DialogTitle id={dialogId}>
                <Typography variant="h3" component="div" className={dialogStyles.title}>
                    <T>Select division</T>
                    <IconButton color="inherit" size="small" onClick={closeDialog}><Close/></IconButton>
                </Typography>
                {showSubtext &&
            <Typography variant="subtitle2" component="p" color="textSecondary" marginTop={2}>
                <PriceDescriptions registrationOptions={registrationOptions} paymentOptions={paymentOptions} />
            </Typography>}
                <Typography component="div" marginTop={2}>
                    <SearchForm inputRef={inputRef} search={searchString} onChange={onSearch}/>
                </Typography>
            </DialogTitle>
            <DialogContent className={dialogStyles.dialogContent}>
                <SimpleList variant="small">
                    {filteredList.map(option => {
                        const registered = getRegisteredEntriesByDivision(athletes, option.optionId);
                        return ({
                            key: option.optionId,
                            subtitle: <OptionLabel label={option.name} subLabel={option.subLabel} marginLeft={0} />,
                            description: registered.length > 0 && <T x={registered.length}>team_entered_x</T>,
                            aside: <Stack direction="row">
                                <OptionPrice price={option.price} discountPrice={option.discountPrice} />
                                <ChevronRight />
                            </Stack>,
                            onClick: selectDivision(option),
                            highlightOnHover: true
                        });
                    })}
                </SimpleList>
            </DialogContent>
        </>
    );
};
